import { render, staticRenderFns } from "./ProgramadorClaseDetalle.vue?vue&type=template&id=96a3ee56&"
import script from "./ProgramadorClaseDetalle.vue?vue&type=script&lang=js&"
export * from "./ProgramadorClaseDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports